import enumeration from "./enumeration";

const BookingItemType = {
  PLACE: "PLACE",
  PRODUCT: "PRODUCT",
  TICKET: "TICKET",
};

export default enumeration(BookingItemType);
